import styled from 'styled-components';

export const Wrapper = styled.div`
	padding-top: 20px;
	position: relative;
`;

export const Container = styled.div`
	margin: 0 auto;
	width: 100%;
	padding: 0 20px;
	max-width: 1760px;

	@media (max-width: 1800px) {
		max-width: 1480px;
	}
`;

export const Social = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;

	@media (max-width: 992px) {
		flex-direction: column-reverse;
		justify-content: center;
	}
`;

export const Start = styled.div`
	display: flex;
	align-items: center;
	gap: 24px;
	width: 100%;

	@media (max-width: 992px) {
		display: grid;
		gap: 14px;
		grid-template-columns: repeat(4, 1fr);

		svg {
			width: 100%;
		}
	}

	@media (max-width: 630px) {
		grid-template-columns: repeat(2, 1fr);
	}
`;

export const End = styled.div`
	@media (max-width: 992px) {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		margin-bottom: 20px;
	}
`;

export const LicenseWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	align-items: center;
`;

export const License = styled.div`
	color: ${({ theme }) => theme.colors.text.body};
	font-size: 12px;
	font-weight: 400;
	text-align: center;
`;

export const SocialWrapper = styled.div`
	align-items: center;
	display: flex;
	gap: 24px;
`;

export const SocialItem = styled.div`
	svg {
		fill: ${({ theme }) => theme.colors.icon.chevron};
	}
`;
